if (!customElements.get('custom-measurements')) {
  class CustomMeasurements extends HTMLElement {
    constructor() {
      super();

      this.toggle = this.querySelector('.custom-measurements__toggle');
      this.modal = this.querySelector('.custom-measurements__modal');
      this.sizeGuideModal = this.querySelector('.custom-measurements__sizeguide-modal');

      this.overlay = this.modal.querySelector('.custom-measurements__overlay');
      this.closeBtn = this.modal.querySelector('.custom-measurements__close');
      this.saveBtn = this.modal.querySelector('.custom-measurements__save');
      this.inputs = this.modal.querySelectorAll('.custom-measurements__field-input');

      this.sizeGuideOverlay = this.sizeGuideModal.querySelector('.custom-measurements__sizeguide-overlay');
      this.sizeGuideCloseBtn = this.sizeGuideModal.querySelector('.custom-measurements__sizeguide-close');

      this.labelMeasurements = this.toggle.dataset.labelMeasurements || 'Enter Your Measurements';
      this.labelSizeGuide = this.toggle.dataset.labelSizeguide || 'Size Guide';

      this.isCustomSelected = false;
      this.storageKey = 'custom-measurements';

      // Move modals to body so they escape any parent stacking context
      document.body.appendChild(this.modal);
      document.body.appendChild(this.sizeGuideModal);

      this.bindEvents();
      this.loadSaved();
      this.syncButtonState();
    }

    bindEvents() {
      this.toggle.addEventListener('click', () => this.handleToggleClick());
      this.overlay.addEventListener('click', () => this.close());
      this.closeBtn.addEventListener('click', () => this.close());
      this.saveBtn.addEventListener('click', () => this.save());

      this.sizeGuideOverlay.addEventListener('click', () => this.closeSizeGuide());
      this.sizeGuideCloseBtn.addEventListener('click', () => this.closeSizeGuide());

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          if (this.modal.getAttribute('aria-hidden') === 'false') this.close();
          if (this.sizeGuideModal.getAttribute('aria-hidden') === 'false') this.closeSizeGuide();
        }
      });

      // Listen for size option changes
      const variantSelects = this.closest('product-variant-selects') || document.querySelector('product-variant-selects');
      if (variantSelects) {
        variantSelects.addEventListener('change', (e) => {
          const target = e.target;
          if (target.type === 'radio' || target.tagName === 'SELECT') {
            this.syncButtonState();
          }
        });
      }
    }

    getSelectedSizeValue() {
      const variantSelects = this.closest('product-variant-selects') || document.querySelector('product-variant-selects');
      if (!variantSelects) return '';
      const checkedRadio = variantSelects.querySelector('input[type="radio"]:checked');
      if (checkedRadio) return checkedRadio.value || '';
      const select = variantSelects.querySelector('select');
      if (select) return select.value || '';
      return '';
    }

    syncButtonState() {
      const value = this.getSelectedSizeValue();
      
      this.isCustomSelected = value.toLowerCase() === 'custom';

      if (this.isCustomSelected) {
        const hasSaved = this.toggle.classList.contains('has-measurements');
        this.toggle.textContent = hasSaved ? 'Measurements Saved \u2713' : this.labelMeasurements;
        
      } else {
        this.toggle.textContent = this.labelSizeGuide;
        this.toggle.classList.remove('has-measurements');
      }
    }

    handleToggleClick() {
      if (this.isCustomSelected) {
        this.open();
      } else {
        this.openSizeGuide();
      }
    }

    open() {
      this.modal.setAttribute('aria-hidden', 'false');
      this.toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      this.closeBtn.focus();
    }

    close() {
      this.modal.setAttribute('aria-hidden', 'true');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    openSizeGuide() {
      this.sizeGuideModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this.sizeGuideCloseBtn.focus();
    }

    closeSizeGuide() {
      this.sizeGuideModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    save() {
      const hasValues = Array.from(this.inputs).some(input => input.value.trim() !== '');

      if (hasValues) {
        this.toggle.classList.add('has-measurements');
        this.toggle.textContent = 'Measurements Saved \u2713';
        this.saveToStorage();
      }

      this.close();
    }

    saveToStorage() {
      const data = {};
      this.inputs.forEach(input => {
        const key = input.dataset.measurement;
        if (input.value) {
          data[key] = input.value;
        }
      });
      localStorage.setItem(this.storageKey, JSON.stringify(data));
    }

    loadSaved() {
      try {
        const saved = localStorage.getItem(this.storageKey);
        if (!saved) return;

        const data = JSON.parse(saved);
        let hasValues = false;

        this.inputs.forEach(input => {
          const key = input.dataset.measurement;
          if (data[key]) {
            input.value = data[key];
            hasValues = true;
          }
        });

        if (hasValues) {
          this.toggle.classList.add('has-measurements');
        }
      } catch (e) {
        // Ignore storage errors
      }
    }
  }

  customElements.define('custom-measurements', CustomMeasurements);
}
